
<script>
let placeholder = "img/placeholder.png";
let selected = "";
let shortcode = "";
let leftclick = false;
let rightclick = false;
let gs = {
	"g1" : {
		"source" : "img/placeholder.png"
	},
	"g2" : {
		"source" : "img/placeholder.png"
	}
}

for (var i = 1; i <= 27; i++) {
	gs["g"+(i).toString()] = {"source" : "img/placeholder.png","sc" : "00"};
} 


let pvp = {
	"helmet" : {
		"sc" : "aa",
		"d" : "Fully Enchanted Helmet",
		"s" : "img/helmet.png"
	},
	"chestplate" : {
		"sc" : "ab",
		"d" : "Fully Enchanted Chestplate",
		"s" : "img/chestplate.png"
	},
	"leggings" : {
		"sc" : "ac",
		"d" : "Fully Enchanted Leggings",
		"s" : "img/leggings.png"
	},
	"boots" : {
		"sc" : "ad",
		"d" : "Fully Enchanted Boots",
		"s" : "img/boots.png"
	},
	"sword" : {
		"sc" : "ae",
		"d" : "Fully Enchanted Sword",
		"s" : "img/sword.png"
	},
	"fortune pickaxe" : {
		"sc" : "af",
		"d" : "Fully Enchanted Fortune Pickaxe",
		"s" : "img/fortune-pick.png"
	},	
	"axe" : {
		"sc" : "ag",
		"d" : "Fully Enchanted Axe",
		"s" : "img/axe.png"
	},
	"shovel" : {
		"sc" : "ah",
		"d" : "Fully Enchanted Shovel",
		"s" : "img/shovel.png"
	},	
	"silk pickaxe" : {
		"sc" : "ai",
		"d" : "Fully Enchanted Silk Touch Pickaxe",
		"s" : "img/silk-pick.png"
	},	
	"bow" : {
		"sc" : "aj",
		"d" : "Fully Enchanted Bow",
		"s" : "img/bow.png"
	},
	"end crystal" : {
		"sc" : "ak",
		"d" : "End Crystal x64",
		"s" : "img/crystal.png"
	},	
	"totem" : {
		"sc" : "al",
		"d" : "Totem of Undying",
		"s" : "img/totem.webp"
	},
	"gaps" : {
		"sc" : "am",
		"d" : "Enchanted Golden Apple x64",
		"s" : "img/gaps.png"
	},
	"arrows" : {
		"sc" : "an",
		"d" : "Arrows x64",
		"s" : "img/arrows.png"
	},	
	"dmg arrows" : {
		"sc" : "ao",
		"d" : "Damage II Arrows x64",
		"s" : "img/damage arrow.png"
	},	

	"bottle of enchanting" : {
		"sc" : "ap",
		"d" : "Bottle of Enchanting x64",
		"s" : "img/bottle-of-enchanting.png"
	},	
	"obby" : {
		"sc" : "aq",
		"d" : "Obsidian x64",
		"s" : "img/obby.png"
	},	
	"strength pot" : {
		"sc" : "ar",
		"d" : "Strength II Potion 1:30",
		"s" : "img/strength-ii.png"
	},	
	"chorus fruit" : {
		"sc" : "as",
		"d" : "Chorus Fruit x64",
		"s" : "img/chorus.png"
	},	
	"ender pearl" : {
		"sc" : "at",
		"d" : "Ender Pearl x16",
		"s" : "img/pearl.png"
	},	
	"elytra" : {
		"sc" : "au",
		"d" : "Full Enchanted Elytra",
		"s" : "img/elytra.png"
	},	
	"rockets" : {
		"sc" : "av",
		"d" : "Firework Rockets x64",
		"s" : "img/firework.png"
	},	
	"echests" : {
		"sc" : "aw",
		"d" : "Ender Chests x64",
		"s" : "img/ender-chests.png"
	},	
	"flint and steel" : {
		"sc" : "ax",
		"d" : "Fully Enchanted flint and steel",
		"s" : "img/flint and steel.png"
	}	
	


}

function makecode(){
	let tempsc = "";
	for (var i = 1; i <= 27; i++){
		tempsc = tempsc + gs["g"+(i).toString()]["sc"];
	}
	shortcode = tempsc;
	shortcode = shortcode.toUpperCase();
	return shortcode;
}

function selectupdate(newselect){	
	selected = newselect;
}

function usecode(){
	let uinput = document.getElementsByClassName('uinput')[0].value;
	uinput = encodeURI(uinput);

	if(uinput.length == 54){
	
	uinput = uinput.toLowerCase();

	//validation

	//split uinput into two's in array
	let twos = []
	for (var l = 0; l <= 54; l=l+2){
		twos.push(uinput.charAt(l)+uinput.charAt(l+1))
	}
	//get img source from pvp dict
	
	//for pair in uinput 
	//get img source from pvp dict: for item in pvp:
	let iteration = 1
	for (var kip in twos){
		let value = twos[kip];
		gs["g"+iteration.toString()] = {"sc":"00","source":"img/placeholder.png"};
		for (var key in pvp){
			if(pvp[key]["sc"] == value){
				let src = pvp[key]["s"];
				gs["g"+iteration.toString()] = {"sc":value,"source":src};
			}
		}
		iteration++
	}
	}
	//gs["g"+iteration.toString()] = {"sc":pair,"source":src}
}

function gplace(pl){
	if(selected != ""){
		if(leftclick == true){
			gs[pl]["source"] = pvp[selected]["s"];
			gs[pl]["sc"] = pvp[selected]["sc"];
			makecode();
		}else if(rightclick == true){
			gs[pl]["source"] = "img/placeholder.png"
			gs[pl]["sc"] = "00";
			makecode();
		}
	}
}

function imgay(pl){
	if(selected != ""){
		gs[pl]["source"] = pvp[selected]["s"];
		gs[pl]["sc"] = pvp[selected]["sc"];
		makecode();
	}
}

document.addEventListener('mousedown', function(event) {
	switch (event.which) {
        case 1:
			leftclick = true;
			console.log("leftdown")
			break;
		case 3:
			rightclick = true;
			console.log("rightdown")
			break;
	}
})

document.addEventListener('mouseup', function(event){
	switch (event.which) {
        case 1:
			leftclick = false;
			console.log("leftup")
			break;
		case 3:
			rightclick = false;
			console.log("rightup")
			break;
	}
})


</script>


<head>
<script src="https://code.jquery.com/jquery-3.4.1.js"></script>
</head>
<body oncontextmenu="return false;">
<main>
<center>
<h1 style="padding:0px;margin:0px;">Shulker Creator</h1>
<p style="margin-top:5px;color:grey;margin-bottom:20px;">Created by sylax</p>
<input class="uinput" style="width:580px;" type="text" placeholder="Shortcode goes here" bind:value={shortcode} on:input={() => usecode()}>
<p style="color:grey;font-size:12px;padding-bottom:5px;">Share your code and paste here to share kits </p>
<hr style="width:35%">
<h2>Items</h2>
<p style="color:grey">Select an item to assign to a slot</p>
<div class="ballergs">
<div class="allgs">
{#each Object.keys(pvp) as name, i}

	<div class="yo-mama-a-baboon">
	{#if selected === name}
	<div class="searchitemd tipo">	
	<img class="{selected === name?'selected':''} searchitem" onmousedown="if (event.preventDefault) event.preventDefault()" draggable="false" unselectable="on" on:mousedown={() => selectupdate(name)} src={pvp[name].s} alt={name}><span>{pvp[name]["d"]}</span>
	</div>
	{/if}

	{#if selected !== name}
	<div class="unselectitemd tipo">	
	<img class="{selected === name?'selected':''} searchitem" onmousedown="if (event.preventDefault) event.preventDefault()" draggable="false" unselectable="on" style="width: 100px;height:100px;" on:mousedown={() => selectupdate(name)} src={pvp[name].s} alt={name}><span>{pvp[name]["d"]}</span>
	</div>
	{/if}
	</div>
	
{/each}
</div>
</div>

<div class="shoinks">
<div class="grid-container i1">
{#each new Array("1","2","3","4","5","6","7","8","9") as i}
	<div class="gi" on:mouseover={() => gplace('g'+i)} on:mousedown={() => imgay('g'+i)}><img class="gitem" draggable="false" unselectable="on" src={gs["g"+i]["source"]} on:mouseover={() => gplace('g'+i)} on:mousedown={() => imgay('g'+i)} alt="placeholder" onmousedown="if (event.preventDefault) event.preventDefault()"></div>
{/each}
</div>
<div class="grid-container i2">
{#each new Array("10","11","12","13","14","15","16","17","18") as i}
	<div class="gi" on:mouseover={() => gplace('g'+i)} on:mousedown={() => imgay('g'+i)}><img class="gitem" draggable="false" unselectable="on" src={gs["g"+i]["source"]} on:mouseover={() => gplace('g'+i)} on:mousedown={() => imgay('g'+i)} alt="placeholder" onmousedown="if (event.preventDefault) event.preventDefault()"></div>
{/each}
</div> 
<div class="grid-container i3">
{#each new Array("19","20","21","22","23","24","25","26","27") as i}
	<div class="gi" on:mouseover={() => gplace('g'+i)} on:mousedown={() => imgay('g'+i)}><img class="gitem" draggable="false" unselectable="on" src={gs["g"+i]["source"]} on:mouseover={() => gplace('g'+i)} on:mousedown={() => imgay('g'+i)} alt="placeholder" onmousedown="if (event.preventDefault) event.preventDefault()"></div>
{/each}
</div> 
</div>
<p style="color:grey;font-size:10px;">Pss, you can click and drag ;D</p>
<div class="advert">
<p style="color:grey">Place your advert here!</p>
</div>

</center>
</main>

</body>
<style>
	:global(html, body) {margin: 0; padding: 0}
main {
		text-align: center;
		padding:1em;
		background-color: #252525;
		scroll-behavior: smooth;
		
	}	
body {
	background-color: #252525;
}
h1, h2, p {
		color:#dddddd;
	}

.shoinks {	
	width:800px;
}
.advert {
	width:800px;
	padding-top:23px;
	padding-bottom:20px;
	background-color:#1f1f1f;
}
.searchitemd {
	width: 100px;
	
	outline: 3px solid white;
}
.searchitem {
	width: 100px;
	height:100px;
	
}
.searchitem:hover{
	width:100%
}
.unselectitemd{
	width: 100px;
}
.unselectitemd:hover{
	transition: 0.2s ease;
	outline: 3px solid white;
}
.yo-mama-a-baboon{
	padding:5px;
	background-color: #1b1b1b;
	width:100px;

	
}

.uinput{
	color: #dddddd;
	background-color:#1f1f1f;
	border-radius: 8px;
	transition: 0.2s ease;
	outline-color:#ececec;

}
.uinput:hover{
	border-radius: 3px;
	transition: 0.2s ease;
	background-color:#272727;
}

.allgs{
	display: flex;
	flex-direction: row;
	width:620px;
	justify-content: center;
	display: flex;
  	flex-wrap: wrap;
	
}
.ballergs{
	width:600px;
	height:230px;
	overflow: scroll;
	overflow-x: hidden;
	
	margin-bottom:10px;
	behavior: 'smooth';

}
.grid-container {
  display: inline-grid;
  grid-gap: 3px;
  background-color: white;
  padding-top: 2px;
	padding-left: 2px;
	padding-bottom: 2px;
	padding-right:4px;
	
}
.gi{
  background-color: #252525;
  text-align: center;
  padding: 10px;
  font-size: 30px;	
  height: 60px;
  color:#d9d9d9;
  transition: 0.2s ease;
  -webkit-user-select: none;
  -moz-user-select: -moz-none;
  -ms-user-select: none;
  user-select: none;
}
.gi:hover{
	background-color:#191919;
	transition: 0.2s ease;
	cursor: pointer;
}
.gitem{
	width:60px;
	-webkit-user-select: none;
    -moz-user-select: -moz-none;
    -ms-user-select: none;
    user-select: none;
}
	
.grid-container div {
  grid-row:1;
}

.tipo {
    text-decoration: none;
	
}
.tipo:hover {
    cursor: crosshair;
    position: relative;
	
}
.tipo span {
    display: none;
}

.tipo:hover span {
	color:#dddddd;
	font-size: 12px;
    padding:3px;
	padding-bottom:5px;
    display: block;
    z-index: 100;
    background: #111111 no-repeat 100% 5%;;
    left: -15px;
    margin: 10px;
   
	width:110px;
    position: absolute;
    top: 60px;
    text-decoration: none;
	border: 1px solid white ;
	border-radius: 5px;
	pointer-events: none;
}
</style>
